// extracted by mini-css-extract-plugin
module.exports = {"section":"_4f720283bf--section--Q5RCM","title":"_4f720283bf--title--GabOe","content":"_4f720283bf--content--QGqXx"};